import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyDialog } from '@angular/material/legacy-dialog';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { take } from 'rxjs';

import { DialogConfig } from 'v2/modules/shared';
import { EShipmentFormDataSource } from 'v2/modules/shared/interfaces/order-shipment.interface';

import { OrderShipmentsFormComponent } from '../../../order-shipments-form/order-shipments-form.component';

@Component({
  selector: 'lum-shipments-grid-actions',
  templateUrl: './shipments-grid-actions.component.html',
  styleUrls: ['./shipments-grid-actions.component.scss'],
  imports: [MatLegacyMenuModule, MatDividerModule, OrderShipmentsFormComponent],
  standalone: true,
})
export class ShipmentsGridActionsComponent {
  @Output()
  refreshGridEvent = new EventEmitter<void>();

  @Output()
  clearGridState = new EventEmitter<void>();

  @Input()
  salesOrderId :number;

  @Input()
  selectedRowIds :number[] = [];

  @Input()
  selectedRowCount :number = 0;

  @Input()
  visibleRows :any[] = [];

  constructor(private dialog :MatLegacyDialog) {}

  onOpenCreateShipmentDialog() :void {
    this.dialog
      .open(OrderShipmentsFormComponent, {
        width: DialogConfig.Size.LARGE,
        data: {
          source: EShipmentFormDataSource.SALES_ORDER,
          sourceId: this.salesOrderId,
        },
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          this.refreshGridEvent.emit();
        }
      });
  }

  onRefreshGrid() :void {
    this.refreshGridEvent.emit();
  }
}
